import React, { useState, useEffect } from "react";
import { Box, Typography, Chip, Grid, Tabs, Tab } from "@mui/material";
import { FaPlus } from "react-icons/fa6";
import CustomButton from "components/Button";
import ABGTrackerList from "./ABGTrackerList";
import PBGTrackerList from "./PBGTrackerList";
import RBGTrackerList from "./RBGTrackerList";
import { useParams } from "react-router-dom";
import { FINANCIALBG_TABS_CONFIG } from "config";
import AddFinancialBG from "./addFinancialBG";
import ProjectLastUpdatedOn from "components/ProjectLastUpdatedOn";
import TrackerPageHeader from "components/TrackerPageHeader";
import { useGetLastUpdatedOnStatusQuery } from "store/slices/apis/projectStatusApiSlice";
import { usePermission } from "hooks/usePermission";
import { FINANCIAL_BG_CREATE } from "helpers/permissionConfig";

const FinancialBGList = () => {
    const [tabValue, setTabValue] = useState(0);
    const [isAdd, setIsAdd] = useState(false)
    const { projectId } = useParams();
    const createAccess = usePermission(FINANCIAL_BG_CREATE);

    const filteredTabs = FINANCIALBG_TABS_CONFIG;

    const handleAdd = () => {
        setIsAdd((prev) => !prev);
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const { data: statusDate } = useGetLastUpdatedOnStatusQuery({ ProjectId: projectId });

    return <>

        <TrackerPageHeader title="Financial BG Tracker" description="Manage bank guarantees, expiry exposure, and current status.">
            {statusDate?.financialBG && <ProjectLastUpdatedOn date={statusDate?.financialBG} />}
        </TrackerPageHeader>
        <Grid container spacing={2} sx={{ p: 2 }}>

            <Grid size={12}>
                <Box
                    sx={{
                        width: "100%",
                        borderBottom: "2px solid #ECECEC",
                        overflowX: "auto",
                        whiteSpace: "nowrap",
                        p: 0,
                        display: "flex", alignItems: "center", justifyContent: 'space-between',
                        "-webkit-overflow-scrolling": "touch",
                    }}
                >
                    <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        TabIndicatorProps={{ style: { display: "none" } }}
                        variant="scrollable"
                        scrollButtons={false}
                        sx={{
                            justifyContent: "flex-start !important",
                            alignItems: "flex-start",
                            "& .MuiTabs-flexContainer": {
                                justifyContent: "flex-start !important",
                                gap: "30px",
                            },
                        }}
                    >
                        {filteredTabs.map((item, index) => (
                            <Tab
                                key={index}
                                label={
                                    <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                        <Typography
                                            sx={{
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                lineHeight: "100%",
                                                color: tabValue === index ? "#0E73F6" : "#7E7E7E",
                                                fontFamily: "Outfit, sans-serif"
                                            }}
                                        >
                                            {item.label}
                                        </Typography>

                                    </Box>
                                }
                                sx={{
                                    textTransform: "none",
                                    minWidth: "auto",
                                    paddingBottom: "14px",
                                    paddingLeft: 0,
                                    paddingRight: 0,
                                    borderBottom: tabValue === index ? "2px solid #0E73F6" : "2px solid transparent",
                                }}
                            />
                        ))}
                    </Tabs>

                    {createAccess &&
                        <CustomButton
                            label="Create Financial BG"
                            startIcon={<FaPlus />}
                            color="primary"
                            onClick={handleAdd}
                            sx={{
                                backgroundColor: "#2563EB",
                                fontFamily: 'Outfit',
                                fontWeight: 500,
                                fontSize: '14px',
                                lineHeight: '100%',
                                letterSpacing: '0px',
                            }}
                        />
                    }

                </Box>
            </Grid>

            {tabValue === 0 && (
                <ABGTrackerList />
            )}
            {tabValue === 1 && (
                <PBGTrackerList />
            )}
            {tabValue === 2 && (
                <RBGTrackerList />
            )}

        </Grid>

        {isAdd &&
            <AddFinancialBG open={isAdd} handleClose={handleAdd} />
        }
    </>
}

export default FinancialBGList;
